const names = new Intl.Collator("zh-Hant-HK", { numeric: true, sensitivity: "base" });
const chineseNumbers = "零一二三四五六七八九";

function classNameParts(value: string) {
  const name = value.normalize("NFKC").trim().toUpperCase();
  const match = /^(?:(?:FORM|S|F)\s*|[中小初高])?(\d+|[一二三四五六七八九十]+)(?:年級|年|級)?\s*/u.exec(name);
  if (!match) return { year: null, name };
  const number = match[1];
  let year = Number(number);
  if (!Number.isFinite(year)) {
    if (number.includes("十")) {
      const [tens, units] = number.split("十");
      year = (tens ? chineseNumbers.indexOf(tens) : 1) * 10 + (units ? chineseNumbers.indexOf(units) : 0);
    } else year = chineseNumbers.indexOf(number);
  }
  if (year < 1) return { year: null, name };
  return { year, name: name.slice(match[0].length) };
}

/** Order presentation without changing class IDs, role groups or saved records. */
export function sortClasses<T extends { name: string }>(classes: readonly T[]): T[] {
  return [...classes].sort((left, right) => {
    const a = classNameParts(left.name);
    const b = classNameParts(right.name);
    if (a.year !== null && b.year !== null) return a.year - b.year || names.compare(a.name, b.name);
    if (a.year !== null) return -1;
    if (b.year !== null) return 1;
    return names.compare(a.name, b.name);
  });
}
